export default (state, { columnsStateKey, studyKey, from, to }) => {
  state[columnsStateKey][studyKey].columnGroups.splice(to, 0, state[columnsStateKey][studyKey].columnGroups.splice(from, 1)[0])
}